import * as React from 'react';

// HOC
import { withAccountInfo } from '@shopee-user/account-hoc';

// Routes
import routeConfig from './routes';

// Hooks
import { useRoutes } from 'react-router-dom';

// Types
import { WithAccountInfoProps } from '@shopee-user/account-hoc';
import { RedirectType } from '@shopee-user/authentication-redirect';

// Components
import {
  GeneralError,
  PageLoading,
} from '@shopee-user/business-customization-ui';
import { Navigate } from 'react-router-dom';

// Constants
import { ErrorCode, APIProgress } from '@shopee-user/api-constants';
import { constants } from '@shopee-user/business-customization-logic';

// Utils
import { appendQueryToUrl } from '@shopee/url-util';

type Props = WithAccountInfoProps;

function PageUser(props: Props): JSX.Element {
  const { accountAPIProgress, accountError, accountInfo } = props;

  const redirectUrl = appendQueryToUrl(constants.AUTHENTICATION_ENTRY_URL, {
    next: location.href,
    redirect_type: RedirectType.External,
    client_id: constants.REDIRECT_CLIENT_ID,
  });

  const elements = useRoutes(routeConfig);

  switch (accountAPIProgress) {
    case APIProgress.Init:
      return <PageLoading />;
    case APIProgress.Requested:
      return <PageLoading />;
    case APIProgress.Failed:
      if (accountError === ErrorCode.NotLoggedIn) {
        return <Navigate to={redirectUrl} />;
      }
      return <GeneralError />;
    case APIProgress.Success:
      if (!accountInfo) {
        return <Navigate to={redirectUrl} />;
      }
      return <>{elements}</>;
    default:
      return <GeneralError />;
  }
}

export default withAccountInfo()(PageUser);
